import React from "react";
import { LifeBuoy } from "lucide-react";

const HELP_TICKET_URL = "https://hq.beyondmeasure.global/ticket/PTE";

/**
 * Persistent, app-wide support entry point. Rendered once at the App root
 * (outside <Routes>) so it stays mounted — and fixed bottom-right — across
 * every page, including pre-login (Login/SetPassword) screens.
 * Opens the Beyond Measure support ticket form in a new tab, tagging the
 * page the user was on via ?from= so support can see where the issue
 * happened without the user losing their current work/session.
 */
export default function NeedHelpButton() {
  const openHelp = () => {
    const from = encodeURIComponent(window.location.href);
    window.open(`${HELP_TICKET_URL}?from=${from}`, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      type="button"
      className="need-help-btn"
      onClick={openHelp}
      title="Need Help? Opens a support ticket in a new tab"
      data-testid="need-help-button"
    >
      <LifeBuoy size={18} />
      <span className="need-help-label">Need Help?</span>
    </button>
  );
}
